import axios from 'axios'
import { Message } from 'element-ui'

// axios.defaults.timeout = 10000
// axios.defaults.baseURL ='http://api.fotomore.com'
axios.defaults.baseURL ='/apiFotomore'

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
    export function get(url, params = {}, headers = {}) {
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params: params,
                headers: {
                    'api-key': headers.client_id,
                    'authorization': `Bearer ${headers.token}`
                }
            }).then((res)=>{
                // console.log('res----- ',res);
                resolve(res.data)
            }).catch((err)=>{
                reject(err)
                // console.log('err----- ',err.response);
            })
        })
    }


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}){
    return new Promise((resolve,reject) => {
        axios.post(url, data, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res => {
            // console.log('res----- ',res);
            resolve(res)
        }).catch((err) => {
            reject(err)
        })
    })
}


/**
 * 图片上传oss
 * @param url
 * @param data
 * @returns {Promise}
 */
export function uploadImage(url, data = {}, headers = {}){
    return new Promise((resolve,reject) => {
        axios.post(url, data, {
            headers: {
                'api-key': headers.client_id,
                'authorization': `Bearer ${headers.token}`,
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res => {
            // console.log('res----- ',res);
            resolve(res)
        }).catch((err) => {
            reject(err)
        })
    })
}



// WEBPACK FOOTER //
// ./src/common/js/require.js